import defaultTo from 'lodash/defaultTo'
import { createSelector } from 'reselect'
import { IShipmentsState } from 'types'
import { IUIState } from 'apps/booking/types'
import { IShipmentState } from 'apps/detention-review/utils/types'
import { IStore } from '../reducers'
import { IAccessTokenState } from '../reducers/accessToken'

const selectShipmentData = (state: IStore): IShipmentState => state.shipmentData

export const selectShipment = createSelector(selectShipmentData, ({ shipment }) => shipment)

const selectShipmentUpdate = (state: IStore): IShipmentsState => state.shipmentUpdate

export const selectShipmentUpdateError = createSelector(selectShipmentUpdate, ({ error }) =>
  defaultTo(error, '')
)

const selectAccessToken = (state: IStore): IAccessTokenState => state.accessToken

export const selectAccessTokenToken = createSelector(selectAccessToken, ({ token }) =>
  defaultTo(token, '')
)

const selectUi = (state: IStore): IUIState => state.ui

export const selectIsDialogOpen = createSelector(selectUi, ({ dialogOpen }) => dialogOpen)
